import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  assignments: [],
}

export const getAssignments = createAsyncThunk('assignment/getAssignments', async (_, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId, customerId } = state.auth

  let assignmentsURL;
  if (authId === 100) {
    assignmentsURL = 'api/gateassignmentsNew/'
  } else if (authId === 1) {
    assignmentsURL = 'api/gateassignmentsNew/subscriber/' + subscriberId;
  } else if (authId === 2) {
    assignmentsURL = 'api/gateassignmentsNew/customer/' + customerId;
  }
  if (!assignmentsURL) return []

  return await fetch(apiURL + assignmentsURL, {
    method: 'get',
    headers: { 'Accept': 'application/json', 'Authorization': webToken },
    credentials: 'include'
  })
  .then(response => response.json())
  .then(data => data.rows)
  .catch(error => {
      console.error('Error:', error)
      return []
  })
});

const assignmentSlice = createSlice({
  name: 'assignment',
  initialState,
  reducers: {
    setAssignmentState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAssignments.fulfilled, (state, action) => {
        state.assignments = action.payload
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setAssignmentState } = assignmentSlice.actions
export default assignmentSlice.reducer
